import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

// Datepicker
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Button, FormSelect, FormInput, Icon, Table, Label } from 'semantic-ui-react';

// Actions
import { setContractData, doContractAction } from "./contractSlice";

// Styles
import './contract.css';


//
registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @param {bool} editMode
 * @returns 
 */
const Max2ContractHeadOfficeStopSales = ({ editMode }) => {
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const StopSales = Contract.StopSales;

  const { t } = useTranslation();

  // Edit mode?
  const readOnly = editMode ? false : true;



  /**
   * 
   * @param {bool} headoffice 
   */
  const handleAddNewRow = (headoffice = false) => {
    dispatch(doContractAction({target: 'StopSale.addRow', value: headoffice}))
  }



  /**
   * 
   */
  const handleDeleteRow = (rowIndex) => {
    dispatch(doContractAction({target: 'StopSale.deleteRow', value: rowIndex}))
  }



  /**
   * 
   */
  const handleCopyRow = (rowIndex) => {
    dispatch(doContractAction({target: 'StopSale.copyRow', value: rowIndex}))
  }


  // If no records
  if (typeof StopSales === 'undefined' || !StopSales  || !StopSales.length) {
    return (
      <> 
        {!readOnly && (
          <>
          <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow()}>
            <Icon name='plus' />
            {t('contract.headoffice.actions.addRow')}
          </Button>
          <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
            <Icon name='plus' />
            {t('contract.headoffice.actions.addRowHeadOffice')}
          </Button>
          </>
        )} 
      </>
    );
  }

  // build options for room select
  const optionsRooms = Contract.Rooms.map(room => {
    return { value: room.RoomCode, key: room.RoomCode, text: room.RoomCode }
  });

  // build options for board select
  let optionsBoards = [];
  Contract.Rooms.forEach(room => {
    let found = false;
    optionsBoards.forEach(board => {
      if (board.value === room.Board) {
        found = true;
      }
    });
    if (!found) {
      optionsBoards.push({ value: room.Board, key: room.Board, text: room.Board })
    }
  });

  return (
    <>
    <Table celled structured striped basic='very'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell></Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.room')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.board')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.from')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.headoffice.table.to')}</Table.HeaderCell>
          {!readOnly && (
            <Table.HeaderCell></Table.HeaderCell>
          )}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {StopSales.map((stopsale, stopsaleKey)=>(
          <Table.Row key={stopsaleKey}>
            <Table.Cell>
              {!stopsale.Additional && (<Label as='a' color='red' ribbon>{t('settings.userDetails.headOffice')}</Label>)}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? <span>{stopsale.Rooms[0]}</span> : <FormSelect search selection options={optionsRooms} value={stopsale.Rooms[0]} placeholder={t('common.pleaseSelect')} onChange={(e, data) => dispatch(setContractData({target: 'StopSales.Rooms', row: stopsaleKey,  value: data.value}))} />}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? <span>{stopsale.Boards[0]}</span> : <FormSelect search selection options={optionsBoards} value={stopsale.Boards[0]} placeholder={t('common.pleaseSelect')} onChange={(e, data) => dispatch(setContractData({target: 'StopSales.Boards', row: stopsaleKey,  value: data.value}))} />}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(stopsale.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  readOnly={readOnly}
                  selected={stopsale.Start}
                  startDate={stopsale.Start}
                  endDate={stopsale.End}
                  dateFormat="dd.MM.yyyy"
                  placeholder={t('contract.specials.modal.datePlaceholder')}
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(stopsale.Start), 1) },
                    { start: new Date(stopsale.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({target: 'StopSales.Start', row: stopsaleKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder={t('contract.specials.modal.datePlaceholder')} style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            <Table.Cell>
              {readOnly ? (
                <span>{format(stopsale.Start, "dd.MM.yyyy")}</span>
              ) : (
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  readOnly={readOnly}
                  selected={stopsale.End}
                  startDate={stopsale.Start}
                  endDate={stopsale.End}
                  minDate={stopsale.Start}
                  dateFormat="dd.MM.yyyy"
                  placeholder={t('contract.specials.modal.datePlaceholder')}
                  excludeDateIntervals={[
                    { start: new Date("1970-01-01"), end: subDays(new Date(stopsale.Start), 1) },
                    { start: new Date(stopsale.End), end: new Date("9999-12-31") },
                  ]}
                  onChange={(date) => dispatch(setContractData({ target: 'StopSales.End', row: stopsaleKey,  value: format(date, "yyyy-MM-dd")}))}
                  customInput={<FormInput inline icon='calendar alternate' iconPosition='left' placeholder={t('contract.specials.modal.datePlaceholder')} style={{width: "130px"}} />}
                />
              )}
            </Table.Cell>
            {!readOnly && (
              <Table.Cell>
                <Button basic circular icon>
                  <Icon name='trash' onClick={() => handleDeleteRow(stopsaleKey)} />
                </Button>
                <Button basic circular icon>
                  <Icon name='copy outline' onClick={() => handleCopyRow(stopsaleKey)} />
                </Button>
              </Table.Cell>
            )}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    {!readOnly && (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow()}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRow')}
      </Button>
      <Button basic circular icon labelPosition='left' onClick={() => handleAddNewRow(true)}>
        <Icon name='plus' />
        {t('contract.headoffice.actions.addRowHeadOffice')}
      </Button>
      </>
    )}
    </>
  );
}

export default Max2ContractHeadOfficeStopSales;
